<template>
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body">
          <b-tabs v-model="tab">
            <b-tab title="التخرج ومنح الدرجة العلمية ">
              <app-timeline>
                <app-timeline-item
                  v-for="item in items"
                  :key="item.id"
                  :title="$t(`master.` + item.key)"
                  :subtitle="variant(item) ? 'في انتظار الموافقة ' : 'موافقة '"
                  :time="moment(item.updated_at).fromNow()"
                  :variant="variant(item) ? 'danger' : 'success'"
                />
              </app-timeline>
              <b-spinner
                v-if="load"
                type="grow"
                label="Loading..."
                class="loading"
              />
            </b-tab>
           
          </b-tabs>
        </div>
        
       
        <!-- end of card body -->
      </div>
      <!-- end of card -->
    </div>
    <!-- end of col -->
  </div>
</template>

<script>
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import uploadVue from "./wizard/upload.vue";
import MasterKeyStatusController from "@/Controllers/MasterKeyStatusController";
import Auth from "@/Apis/Auth";
import AppTimeline from "@core/components/app-timeline/AppTimeline.vue";
import AppTimelineItem from "@core/components/app-timeline/AppTimelineItem.vue";
import MastersDataController from "@/Controllers/MastersDataController";
import MastersController from '@/Controllers/MastersController';
// Department
export default {
  components: {
    FormWizard,
    TabContent,
    uploadVue,
    AppTimeline,
    AppTimelineItem,
  },
  data() {
    return {
      tab: 0,
      items: [],
      masterId: Auth.MASTER.id,
      load: true,
    };
  },
  async created() {
    this.load = true;
 
    const timeLine = new MastersController().timeLine();
    const key = timeLine
      .find((a) => a.code == "graduation")
      .phases.map((a) => {
        return a.code;
      });
    const res = await new MasterKeyStatusController().GetAll({
      filter: "master_id|" + this.masterId,
      filterIn: "key|" + key.toString(),
      with: ["mastersData" ],
    });

    this.items = res;
    this.load = false;
  },
  methods: {
    setTab(res, key) {
      const find = res.find((a) => a.key == key);
      if (find) return true;
      return false;
    },
    variant(item) {
      return item.value == null || item.value == "" || item.value == "-1";
    },
    async validateStep(name) {
      const refToValidate = this.$refs[name];
      console.log(refToValidate);
      const returnData = await refToValidate.returnData();
      if (!returnData.valid) return false;

      return true;
    },
    async formSubmitted() {
      this.$router.push({ name: "Thesis" });
    },
  },
};
</script>

<style>
</style>